import isObject from 'lodash/isObject';

export const getTabCQItemsWithAppliedClasses = <P>(cqItems: Record<string, P>, appliedCssClassNames: string) =>
  cqItems
    ? Object.fromEntries(
        Object.entries(cqItems).map((tabProp) =>
          tabProp?.map((tProp, index) => {
            if (index === 1 && isObject(tProp)) {
              return { ...tProp, appliedCssClassNames };
            }
            return tProp;
          })
        )
      )
    : null;
